import { render } from "./GameView.vue?vue&type=template&id=f6803ff8&ts=true"
import script from "./GameView.vue?vue&type=script&lang=ts"
export * from "./GameView.vue?vue&type=script&lang=ts"

import "./GameView.vue?vue&type=style&index=0&id=f6803ff8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__